import * as yup from "yup";

import { VerificationDecision, RejectionReasons } from "../../constants";

export const resellerValidationSchema = yup.object({
  resellerId: yup.string().required(),
  decision: yup.string().required("Please make validation decision"),
  rejectionReason: yup
    .string()
    .nullable()
    .when("decision", {
      is: (decision: VerificationDecision) =>
        decision === VerificationDecision.Decline,
      then: () => yup.string().required("Please enter a rejection reason")
    }),
  otherRejectionReason: yup.string().when("rejectionReason", {
    is: (rejectionReason: RejectionReasons) =>
      rejectionReason === RejectionReasons.Other,
    then: () => yup.string().required("Please enter a rejection reason")
  })
});
